var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFileSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4589 22.6998C16.9804 21.1413 20.2034 17.5183 20.7089 12.9053C20.8489 10.9028 20.8374 8.89279 20.6734 6.89179C20.6519 6.57639 20.5135 6.28037 20.2853 6.06159C20.057 5.84282 19.7554 5.71702 19.4394 5.70879C17.3939 5.64579 15.0164 5.30479 13.1794 3.49529C12.9876 3.30583 12.7288 3.19958 12.4592 3.19958C12.1895 3.19958 11.9308 3.30583 11.7389 3.49529C9.90142 5.30479 7.52392 5.64579 5.47892 5.70879C5.16289 5.71702 4.86129 5.84282 4.63309 6.06159C4.40488 6.28037 4.26647 6.57639 4.24492 6.89179C4.0809 8.8925 4.06887 10.9028 4.20892 12.9053C4.71492 17.5183 7.93742 21.1413 12.4589 22.6998Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4558 8.82666V10.4301C13.4558 10.6472 13.5423 10.8559 13.6966 11.0097C13.8513 11.1637 14.0607 11.2501 14.2789 11.25H16.1182",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1597 11.4194V15.2398C16.1508 15.4896 16.0926 15.7353 15.9884 15.9626C15.8842 16.1899 15.736 16.3943 15.5524 16.564C15.3687 16.7346 15.1531 16.8672 14.9181 16.9545C14.6831 17.0417 14.4332 17.0817 14.1826 17.0723H10.7984C10.5463 17.0839 10.2945 17.0455 10.0573 16.9595C9.82012 16.8735 9.60224 16.7415 9.41615 16.5712C9.23078 16.4009 9.08109 16.1956 8.97576 15.967C8.87044 15.7385 8.81158 15.4913 8.80261 15.2398V10.6587C8.81147 10.4089 8.86968 10.1632 8.97391 9.93592C9.07814 9.70864 9.22632 9.50423 9.40991 9.33448C9.59365 9.16394 9.80919 9.03127 10.0442 8.94405C10.2792 8.85683 10.5291 8.81678 10.7797 8.82617H13.3274C13.7164 8.8248 14.0918 8.9687 14.3802 9.22969L15.7 10.4434C15.8408 10.5647 15.9545 10.7143 16.0337 10.8825C16.1129 11.0506 16.1559 11.2336 16.1597 11.4194Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFileSecure);
export default __webpack_public_path__ + "static/media/ic-file-secure.6aa17bfe95568c1c63d615504a3a6422.svg";
export { ForwardRef as ReactComponent };